/// <reference path="./_references.ts"/>

module App.Administrative {
    export interface CheckListItem {
        displayName: string,
        name: string,
        sref?: string,
        isSelected?: boolean
    }

    export interface AppointmentCheckListItem extends CheckListItem {
        status?: () => string,
        permission: string,
        required: boolean
    }

    export type AppointmentChecklist = {
        id?: number,
        create_purchase_order?: boolean,
        email_recommendations?: boolean,
        upload_photos?: boolean,
        send_review_request?: boolean,
        replenish_truck_inventory?: boolean,
        organization?: number,
        close_service_request_on_complete?: boolean,
        [k: string]: boolean | number;
    }

    export type ServiceRequestChecklist = {
        id?: number,
        contact_customer?: boolean,
        follow_up_recommendation?: boolean,
        order_supplies?: boolean,
        appointment_service_request_complete?: boolean,
        organization?: number,
        upload_on_complete?: boolean,
        email_on_complete?: boolean,
        invoice_note?: string,
        invoice_email?: string,
        review_count?: number,
        callsource_review_count?: number,
        image_count?: number,
        [k: string]: boolean | number | string;
    }

    export type Note = {
        id: number,
        user: string,
        customer: string,
        description: string
    }

    export interface AppRootScope extends ng.IRootScopeService {
        app: {
            startAppLoading:() => void;
            stopAppLoading:() => void;
            isAppLoading?: boolean;

            showAppHeader:() => void;
            generateGuid:() => void;
            hideAppHeader:() => void;
            getTitle:() => string;
            isHeaderShown: boolean;
            initElement: (selector: string) => void;

            setOrganization: (id: number) => void;

            getClockedStatusColor: (timeclock: boolean) => string;
            getClockedStatusText: () => string;
            showTimeEvents: () => void;
        }
    }

    export interface ServiceRequestPhoto {
        id?: number;
        url: string;
        file_type: string;
        caption?: string;
        send_with_invoice?: boolean;
        send_with_recommendation?: boolean;
    }

    export interface GameConfig {
        id: number,
        visible: boolean,
        description: string,
        ranks: GameRank[]
    }

    export interface SRScore {
        id?: number,
        points_psq_completed: number,
        psq_completed: boolean,
        points_items_catalogued: number,
        items_catalogued: boolean,
        points_items_maintained: number,
        items_maintained: boolean,
        points_item_report_sent: number,
        item_report_sent: boolean,
        points_ssp_sold: number,
        ssp_sold: boolean,
        points_signature_captured: number,
        signature_captured: boolean,
        points_etc_updated: number,
        etc_updated: boolean,
        points_recommendation_emailed: number,
        recommendation_emailed: boolean,
        points_photos_uploaded: number,
        photos_uploaded: boolean,
        points_po_made: number,
        po_made: boolean,
        points_inventory_replenished: number,
        inventory_replenished: boolean,
        points_review_requested: number,
        review_requested: boolean,
        points_note_left: number,
        note_left: boolean,
        points_sale_min: number,
        sale_min: boolean,
        points_sale_goal: number,
        sale_goal: boolean,
        points_minutes_goal: number,
        minutes_goal: boolean,
        total_points: number,
        points: number,
        percent: number,
        complete: boolean
    }

    export interface TechData {
        [date: string]: number;
    }

    export interface TechScore {
        id: number,
        average: number,
        rank: GameRank,
        data: TechData,
        all_data: TechData,
        team_data: TechData,
    }

    export interface GameRank {
        id: number,
        image_url: string,
        name: string,
        percent?: number,
        description: string
    }
}